<div class="content">
    <div class="part">
        <h6>Дете</h6>
        <div class="flex cards">
            <div class="card">
                <h5 class="ig-typography__body-2">Име</h5>
                <h3 class="ig-typography__subtitle-1">{{ kid?.name }}</h3>
            </div>
            <div class="card">
                <h5 class="ig-typography__body-2">Възраст</h5>
                <h3 class="ig-typography__subtitle-1">{{ calculateKidAge(kid!) }}</h3>
            </div>
            <div class="card">
                <h5 class="ig-typography__body-2">Дата на раждане</h5>
                <h3 class="ig-typography__subtitle-1">{{ kid?.birthDate | date:"dd/MM/yyyy" }}</h3>
            </div>
            <div class="card">
                <h5 class="ig-typography__body-2">Спортове и нива</h5>
                @for(kidSport of kid?.sports ?? []; track kidSport.id) {
                <h3 class="ig-typography__subtitle-1">{{ kidSport.sport?.name }} - {{ kidSport.level?.name}}</h3>
                } @empty {
                <h3 class="ig-typography__subtitle-1">Няма записани спортове</h3>
                }
            </div>
        </div>
    </div>
    @if(request){
    <div class="part">
        <h6>Заявка</h6>
        <div class="flex cards">
            <div class="card">
                <h5 class="ig-typography__body-2">Програма</h5>
                <h3 class="ig-typography__subtitle-1">{{ requestedProgram?.name }}</h3>
            </div>
            <div class="card">
                <h5 class="ig-typography__body-2">Продукт</h5>
                @if(request.product && request.product.length > 0){
                <h3 class="ig-typography__subtitle-1">{{ request.product }}</h3>
                }
                @else {
                <h3 class="ig-typography__subtitle-1">{{ "Без продукт" }}</h3>
                }
            </div>
            <div class="card">
                <h5 class="ig-typography__body-2">Спорт</h5>
                <h3 class="ig-typography__subtitle-1">{{ requestedSport?.name ?? "Без спорт" }}</h3>
            </div>
            <div class="card">
                <h5 class="ig-typography__body-2">Ниво</h5>
                <h3 class="ig-typography__subtitle-1">{{ requestedLevel?.name ?? "Без ниво" }}</h3>
            </div>
        </div>
        <div class="flex wrap">
            @if(request.package){
            @for(date of request.dates; track date){
            <div class="card">
                <h5 class="ig-typography__body-2">{{ generatePackageDescription(date) }}</h5>
            </div>
            }
            } @else {
            @for(date of request.dates; track date){
            <div class="card wrap">
                <h3 class="ig-typography__subtitle-1">{{ date| date:"dd/MM/yyyy" }}</h3>
            </div>
            }
            }
        </div>
    </div>
    }
    <div class="part">
        <div class="actions">
            <igx-select style="flex-grow: 1;" type="border" [(ngModel)]="program">
                <label igxLabel>Програма</label>
                @for(p of programs | sorting; track p.id) {
                <igx-select-item [value]="p">{{p.name}}</igx-select-item>
                }
            </igx-select>
            <igx-simple-combo type="border" [data]="products" [displayKey]="'name'" [(ngModel)]="product"
                [disabled]="products.length < 1">
                <label igxLabel>Продукт</label>
            </igx-simple-combo>
            <igx-simple-combo type="border" [data]="sports | sorting" displayKey="name" [(ngModel)]="sport"
                [disabled]="sports.length < 1">
                <label igxLabel>Спорт</label>
            </igx-simple-combo>
            <igx-simple-combo type="border" [data]="levels | sorting" displayKey="name" [(ngModel)]="level"
                [disabled]="levels.length < 1">
                <label igxLabel>Ниво</label>
            </igx-simple-combo>
        </div>
        <div class="flex right">
            <igx-checkbox [(ngModel)]="withFriends" ngDefaultControl>Аз и приятел</igx-checkbox>
            <igx-checkbox [(ngModel)]="withSiblings" ngDefaultControl>Второ дете</igx-checkbox>
            <p style="min-width: 125px;">Общо: {{totalPrice | number:'1.2-2'}}</p>
            <p style="min-width: 125px;">Депозит: {{totalDeposit | number:'1.2-2'}}</p>
        </div>
        @if(requestedPeriodDates.length > 0){
        <igx-list class="list">
            @for(requestedDate of requestedPeriodDates; track requestedDate.date) {
            <igx-list-item>
                <div class="flex column">
                    <p>{{ requestedDate.period?.description }} |
                        {{ capacityFree(requestedDate.period!, undefined) }}/{{ requestedDate.period!.capacity }} места
                        |
                        {{ getPeriodLevels(requestedDate.period!) }} | {{ getPeriodAge(requestedDate.period!) }}</p>
                    @if(requestedDate.period) {
                    <div class="period">
                        <div class="card">
                            <h5 class="ig-typography__body-2">Цена</h5>
                            <h3 class="ig-typography__subtitle-1">
                                {{requestedDate.grossPrice}}
                                <button igxIconButton="flat"
                                    (click)="startUpdatePart(editDialog, requestedDate, 'grossPrice')">
                                    <igx-icon>edit</igx-icon>
                                </button>
                            </h3>
                        </div>
                        <div class="card">
                            <h5 class="ig-typography__body-2">Отстъпка</h5>
                            <h3 class="ig-typography__subtitle-1">
                                {{requestedDate.discount}}
                                <button igxIconButton="flat"
                                    (click)="startUpdatePart(editDialog, requestedDate, 'discount')">
                                    <igx-icon>edit</igx-icon>
                                </button>
                            </h3>
                        </div>
                        <div class="card">
                            <h5 class="ig-typography__body-2">Дни</h5>
                            <h3 class="ig-typography__subtitle-1">{{requestedDate.period.packageDuration}}</h3>
                        </div>
                        <div class="card">
                            <h5 class="ig-typography__body-2">Крайна</h5>
                            <h3 class="ig-typography__subtitle-1">{{requestedDate.netPrice}}</h3>
                        </div>
                        <div class="card">
                            <h5 class="ig-typography__body-2">Депозит</h5>
                            <h3 class="ig-typography__subtitle-1">
                                {{requestedDate.deposit}}
                                <button igxIconButton="flat"
                                    (click)="startUpdatePart(editDialog, requestedDate, 'deposit')">
                                    <igx-icon>edit</igx-icon>
                                </button>
                            </h3>
                        </div>
                        <div class="card">
                            <h5 class="ig-typography__body-2">Сума депозит</h5>
                            <h3 class="ig-typography__subtitle-1">
                                {{requestedDate.depositAmount}}
                                <button igxIconButton="flat"
                                    (click)="startUpdatePart(editDialog, requestedDate, 'depositAmount')">
                                    <igx-icon>edit</igx-icon>
                                </button>
                            </h3>
                        </div>
                        <div class="card">
                            <h5 class="ig-typography__body-2">Детайли</h5>
                            <h3 class="ig-typography__subtitle-1">
                                <igx-switch [(ngModel)]="requestedDate.showDetails" ngDefaultControl></igx-switch>
                            </h3>
                        </div>
                        <div class="card">
                            <h5 class="ig-typography__body-2">Записан</h5>
                            <h3 class="ig-typography__subtitle-1">
                                <igx-checkbox [checked]="isChecked(requestedDate)"
                                    [indeterminate]="isIndeterminate(requestedDate)"
                                    (change)="periodCheckedChange($event, requestedDate)">
                                    Всички дати
                                </igx-checkbox>
                            </h3>
                        </div>
                    </div>
                    <div class="flex cards">
                        @if(requestedDate.period && requestedDate.showDetails) {
                        @for(pd of requestedDate.packageDates; track pd.date) {
                        <div>
                            <h5 class="ig-typography__body-2">{{pd.date| date}}</h5>
                            <igx-checkbox class="ig-typography__subtitle-1" [checked]="pd.selected"
                                (change)="periodDateCheckedChange($event, pd, requestedDate)">Записан</igx-checkbox>
                        </div>
                        }
                        }
                    </div>
                    }
                    @else {
                    <div class="period">
                        <div style="min-width: 300px;">
                            <h5 class="ig-typography__body-2">За заявените продукт, спорт и ниво няма предвидени
                                дати</h5>
                            <h3 class="ig-typography__subtitle-1">Изберете продукт, спорт и ниво</h3>
                        </div>
                    </div>
                    }
                </div>
            </igx-list-item>
            }
        </igx-list>
        }
        @if(requestedDates.length > 0){
        <igx-list class="list">
            @for(requestedDate of requestedDates; track requestedDate.date) {
            <igx-list-item>
                <div class="period">
                    @if(requestedDate.period) {
                    <div class="card">
                        <h5 class="ig-typography__body-2">
                            {{ requestedDate.date | date}} |
                            {{capacityFree(requestedDate.period, requestedDate.date)}}/{{requestedDate.period.capacity}}
                            места
                        </h5>
                        <h5 class="ig-typography__body-2">
                            {{ getPeriodLevels(requestedDate.period!) }} | {{getPeriodAge(requestedDate.period!) }}
                        </h5>

                    </div>
                    <div class="card">
                        <h5 class="ig-typography__body-2">Цена</h5>
                        <h3 class="ig-typography__subtitle-1">
                            {{requestedDate.grossPrice}}
                            <button igxIconButton="flat"
                                (click)="startUpdatePart(editDialog, requestedDate, 'grossPrice')">
                                <igx-icon>edit</igx-icon>
                            </button>
                        </h3>
                    </div>
                    <div class="card">
                        <h5 class="ig-typography__body-2">Отстъпка</h5>
                        <h3 class="ig-typography__subtitle-1">
                            {{requestedDate.discount}}
                            <button igxIconButton="flat"
                                (click)="startUpdatePart(editDialog, requestedDate, 'discount')">
                                <igx-icon>edit</igx-icon>
                            </button>
                        </h3>
                    </div>
                    <div class="card">
                        <h5 class="ig-typography__body-2">Дни</h5>
                        <h3 class="ig-typography__subtitle-1">{{requestedDate.period.packageDuration}}</h3>
                    </div>
                    <div class="card">
                        <h5 class="ig-typography__body-2">Дневно</h5>
                        <h3 class="ig-typography__subtitle-1">{{requestedDate.grossPrice! /
                            requestedDate.period.packageDuration |
                            number: '1.0-0'}}</h3>
                    </div>
                    <div class="card">
                        <h5 class="ig-typography__body-2">Крайна</h5>
                        <h3 class="ig-typography__subtitle-1">{{requestedDate.netPrice | number:'1.0-0'}}</h3>
                    </div>
                    <div class="card">
                        <h5 class="ig-typography__body-2">Депозит</h5>
                        <h3 class="ig-typography__subtitle-1">
                            {{requestedDate.deposit}}
                            <button igxIconButton="flat"
                                (click)="startUpdatePart(editDialog, requestedDate, 'deposit')">
                                <igx-icon>edit</igx-icon>
                            </button>
                        </h3>
                    </div>
                    <div class="card">
                        <h5 class="ig-typography__body-2">Сума депозит</h5>
                        <h3 class="ig-typography__subtitle-1">
                            {{requestedDate.depositAmount}}
                            <button igxIconButton="flat"
                                (click)="startUpdatePart(editDialog, requestedDate, 'depositAmount')">
                                <igx-icon>edit</igx-icon>
                            </button>
                        </h3>
                    </div>
                    <igx-checkbox [checked]="requestedDate.dateIsSelected"
                        (change)="dateCheckedChange($event, requestedDate)">Записан</igx-checkbox>
                    }
                    @else {
                    <div style="min-width: 300px;">
                        <h5 class="ig-typography__body-2">Датата не е налична за избраните продукт, спорт и ниво</h5>
                        <h3 class="ig-typography__subtitle-1">Изберете продукт, спорт и ниво</h3>
                    </div>
                    }
                </div>
            </igx-list-item>
            }
        </igx-list>
        }
    </div>
    <div class="flex right">
        <button igxButton="outlined" (click)="cancel()" igxStart>Откажи</button>
        <button igxButton="contained" (click)="create()" igxStart>Запиши</button>
    </div>
</div>
<igx-dialog #editDialog>
    <igx-dialog-title>{{dialogTitle}}</igx-dialog-title>
    <igx-input-group type="border">
        <label igxLabel>{{inputLabel}}</label>
        <input #editInput igxInput type="number" [(ngModel)]="editValue" igxTextSelection="true" />
    </igx-input-group>
    <div igxDialogActions>
        <button igxButton="outlined" (click)="endUpdatePart(editDialog, false)">Откажи</button>
        <button igxButton="contained" (click)="endUpdatePart(editDialog, true)">Запиши</button>
    </div>
</igx-dialog>